import {call, fork, put, select, take} from "redux-saga/effects";
import {IApplicationState} from "../../index";
import {IStoreProductConfiguration} from "../../settings/types";
import {getAddBonusAction} from "../../player/types";
import {showBonusAwardDialog} from "../../dialog-manager/dialogs/showBonusAwardDialog";
import {closeDialog} from "../../dialog-manager/actions";
import {consume} from "../actions";
import {trackError} from "../../log/actions";
import {LogLevel} from "../../log/types";
import {delay} from "redux-saga";
import { IPurchase } from "../../../sdk/types";
import { SDK } from "../../../sdk";

export default function* consumeProduct(purchaseInfo: IPurchase) {
    const {products, consumeRetryCount, consumeRetryTimeout} = yield select(({ settings }: IApplicationState) => settings.store);

    yield put(consume.request(purchaseInfo.productId));

    const productConfiguration = products.find((item: IStoreProductConfiguration) => item.productId === purchaseInfo.productId);
    if (!productConfiguration) {
        yield put(consume.failure(purchaseInfo.productId));

        yield put(trackError({
            logLevel: LogLevel.Fatal,
            category: "paymentsSaga",
            message: "Failed to consume product",
            data: {
                error: "Product configuration is undefined",
            }
        }));

        return;
    }

    let lastError: Error;

    for (let i = 0; i < consumeRetryCount; i++) {
        try {
            yield call([SDK.instance, SDK.instance.consumePurchase], purchaseInfo);

            const bonusAction = yield call(getAddBonusAction, productConfiguration.bonus, productConfiguration.amount, "bought_in_app_purchase");
            yield put(bonusAction);

            yield fork(showBonusAwardDialog, { bonus: productConfiguration.bonus, count: productConfiguration.amount });

            yield put(consume.success(purchaseInfo.productId));

            yield take(closeDialog);

            return;
        }
        catch (error) {
            lastError = error;

            yield delay(consumeRetryTimeout);
        }
    }

    yield put(consume.failure(purchaseInfo.productId));

    yield put(trackError({
        logLevel: LogLevel.Fatal,
        category: "paymentsSaga",
        message: "Failed to consume product",
        data: {
            error: lastError!,
        }
    }));
}